module.exports = __webpack_public_path__ + "static/logobtn-56847a64098a8a9408ec08f33f7536d2.png";